import React, { useContext } from 'react';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactReduxContext } from 'react-redux';
import Badge from '../../badges/Badge';
import {
  setMinimizeFilteredFeatureResults,
  setIsFilteredFeatureResultsOpen
} from '../../../state/slices/uiSlice';
import { theme } from '../../../theme/theme';
import { setFeatureFilterPayload, setFilteredFeatureResults } from '../../../state/slices/rpcSlice';
import { useAppSelector } from '../../../state/hooks';

const FilteredFeatureResultsBadge = () => {
  const { store } = useContext(ReactReduxContext);
  const actionKey = useAppSelector((state) => state.rpc.actionKey);

  const handleCloseBadge = () => {
    store.dispatch(setFeatureFilterPayload(null));
    store.dispatch(setIsFilteredFeatureResultsOpen(false));
    store.dispatch(setFilteredFeatureResults([]));
    store.dispatch(setMinimizeFilteredFeatureResults(false));
  };

  return (
    <Badge
      idPrefix={'filtered-features'}
      title={actionKey}
      bg={theme.colors.mainColor1}
      actionButtons={[
        <div
          key="expand"
          onClick={() =>
            store.dispatch(setMinimizeFilteredFeatureResults(false))
          }
          style={{ cursor: 'pointer' }}
        >
          <FontAwesomeIcon icon={faExpand} />
        </div>
      ]}
      closeAction={handleCloseBadge}
    />
  );
};

export default FilteredFeatureResultsBadge;
